import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import Select from 'react-select';
import classnames from 'classnames';
import _ from 'lodash';

import 'react-select/dist/react-select.css';

const SelectCheckboxFormik = props => {
  const {
    autoBlur,
    children,
    checked,
    className,
    classNameContainer,
    clearable,
    closeOnSelect,
    disabled,
    field,
    fieldRemovable,
    form,
    id,
    label,
    labelCheck,
    multi,
    onCheck,
    options,
    placeholder,
    required,
    selectVisible,
  } = props;

  const { errors, submitCount, touched } = form;
  let validationState = null;
  let errorText = null;

  if (touched[field.name] || submitCount > 0) {
    if (errors[field.name]) {
      validationState = 'danger';
      errorText = errors[field.name];
    } else {
      validationState = 'success';
    }
  }

  let selectOptions;
  if (options) {
    selectOptions = options;
  } else {
    let optionChildren = children;
    if (children && !{}.hasOwnProperty.call(children, 'length')) {
      optionChildren = [children];
    }

    selectOptions = _.map(optionChildren, child => ({
      value: child.props.value,
      label: child.props.children,
    }));
  }

  const onChange = multi
    ? values => form.setFieldValue(field.name, values.map(val => val.value))
    : val => form.setFieldValue(field.name, val ? val.value : val);

  return (
    <FormGroup
      row
      color={validationState}
      className={classnames('form-group-row', classNameContainer)}
    >
      <div className="form-group-row__label-container">
        <Label for={id} className="form-group-row__label form-group-row__label-with-checkbox">
          {required ? (
            <span>
              {label} <span className="text-orange">*</span>
            </span>
          ) : (
            label
          )}
        </Label>
        <div>
          <Input
            checked={checked}
            disabled={disabled}
            id={`${id}-checkbox-all`}
            onChange={onCheck}
            type="checkbox"
          />
          <Label
            for={`${id}-checkbox-all`}
            className="form-group-row__label form-group-row__visible-label"
          >
            {labelCheck}
          </Label>
        </div>
      </div>

      {selectVisible && (
        <div className="d-flex">
          <Col className="form-group-row__col">
            <Select
              {...field}
              autoBlur={autoBlur}
              className={className}
              clearable={clearable}
              closeOnSelect={closeOnSelect}
              disabled={disabled}
              multi={multi}
              onBlur={() => {}}
              onChange={onChange}
              options={selectOptions}
              placeholder={placeholder}
            />
            <FormFeedback>{errorText}</FormFeedback>
          </Col>

          {fieldRemovable && (
            <div className="d-none d-sm-block">
              <Button className="ml-auto" color="link" onClick={fieldRemovable}>
                <i className="icon-trash-o" aria-hidden="true" />
              </Button>
            </div>
          )}
        </div>
      )}
    </FormGroup>
  );
};

SelectCheckboxFormik.propTypes = {
  autoBlur: PropTypes.bool,
  checked: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  clearable: PropTypes.bool,
  closeOnSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({}),
  fieldRemovable: PropTypes.func,
  form: PropTypes.shape({}),
  id: PropTypes.string,
  input: PropTypes.shape({ onChange: PropTypes.func }),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelCheck: PropTypes.string,
  meta: PropTypes.shape({}),
  multi: PropTypes.bool,
  onCheck: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  selectVisible: PropTypes.bool,
};

SelectCheckboxFormik.defaultProps = {
  autoBlur: false,
  checked: false,
  className: null,
  clearable: false,
  closeOnSelect: true,
  disabled: false,
  multi: false,
  options: null,
  placeholder: '',
  required: false,
  selectVisible: true,
};

export default SelectCheckboxFormik;
